import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddedTripTypePage } from './added-trip-type.page';

const routes: Routes = [
  {
    path: '',
    component: AddedTripTypePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddedTripTypePageRoutingModule {}
